import React, {useState, useEffect} from "react";
import {API} from './api-service';
import {useCookies} from 'react-cookie';
import Modal from 'react-bootstrap/Modal';
import { FadeLoader } from "react-spinners";
import Button from "react-bootstrap/esm/Button";
import Collapsible from "./components/collapsible";

export default function Insurer(props){

    const [username, setUsername] = useState ('');
    const [password, setPassword] = useState ('');
    const [token, setToken] = useState('')
    const [incorrect, setIncorrect] = useState(false);
    const [loading, setLoading] = useState(false);
    const [connected, setConnected] = useState(true);
    const [loggedIn, setLoggedIn] = useState(false);
    const [cases, setCases] = useState([])

    const submit = evt => {
        evt.preventDefault();
        API.checkInsurer({'insurer':username, 'pass':password}).then(resp => {setLoggedIn(resp.valid); resp.valid && setToken(resp.token)});
    }

    const logoutClicked = () => {
        window.location.href = '/login';
    }

    // useEffect(() => {
    //     console.log
    //     if(loggedIn){
    //         API.loginInsurer(username, token).then(resp => console.log(resp));
    //     }
    // }, [loggedIn])

    useEffect(() => {
        if(loggedIn){
            API.loginInsurer(username, token).then(resp => setCases(resp));
        }
    }, [token])


    useEffect(() => {
        console.log(cases[0]);
    }, [cases])
    
    return(
        <div style={{height:"100vh"}}>
            {!loggedIn?
                <>
                    <header className="App-header" style={{height: "calc(2em + 2.5vh)", backgroundImage: "linear-gradient(to right, #2B6DFE , #00F2FF)"}}>
                        <span/>
                        <h1 className='App-title'>Phleb-O-Nurse</h1>
                        <span/>
                    </header>
                    <div style={{height: "100%", display: "grid", gridTemplateRows: "1fr 2.1fr"}}>
                        <div style={{backgroundImage: "linear-gradient(to right, #2B6DFE , #00F2FF)"}}></div>
                        <div style={{background: "#72BA59"}}></div>
                    </div>
                    <Modal
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show="true"
                    backdropClassName="backdrop"
                    //size="lg"
                    >
                        <Modal.Header style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundImage: "linear-gradient(to right, #2B6DFE , #00F2FF)",
                            color: "white",
                            border: "0px",
                            borderRadius: "10px 10px 0px 0px"
                        }}>
                            <Modal.Title id="contained-modal-title-vcenter">
                                <h1 className="login-header">Insurer Login</h1>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{backgroundColor: "#FFFBD8", paddingTop: "40px", borderRadius: "0px 0px 10px 10px"}}>
                            <form className="login-form" onSubmit={submit}>
                                <label>Insurer Name</label>
                                <input  id='username' type='text' placeholder="Username" value={username}
                                    onChange={evt => {setUsername(evt.target.value)}} required/> 
                                <label>Password</label>
                                <input  id='password' type='password' placeholder="Password" value={password}
                                    onChange={evt => {setPassword(evt.target.value)}}/>
                                <span/>
                                <span/>
                                <span/>
                                <input className="btn btn-login btn-primary" type="submit" value=" Login "/>
                                <span/>
                                <a className="btn btn-login btn-primary" href="/login">Nurse/Admin</a>
                            </form>
                            
                        </Modal.Body>
                    </Modal>
                </>:
                <div className="App">
                    <header className="App-header">
                        <span></span>
                        <h1 className='App-title'>Phleb-O-Nurse</h1>
                        <Button variant="light" className='switch' onClick={() => logoutClicked()}>Logout</Button>
                        <span></span>
                        <div className='App-view'>Insurer - {cases[0]? cases[0].insurance_company : 0}</div>
                    </header>
                    <br/>
                    <Collapsible title={"Case Management"}>

                        <div className='case headings'>
                            <div className='case-headings one'>Reference</div>
                            <div className='case-headings two'>Test Type</div>
                            <div className='case-headings two'>Test Details</div>
                            <div className='case-headings four'>Status</div>
                        </div>
                        {cases.map( (CASE, i) => {return((
                            
                            <div className='case'>
                                <div className='case-text 1'>{CASE.policy_number}</div>
                                <div className='case-text 2'>{CASE.test_type}</div>
                                <div className='case-text 3'>{CASE.test_details}</div>
                                <div className='case-text 4'>{CASE.feedback_status}</div>
                            </div>
                            
                        ))})}
                    </Collapsible>
                </div>
            }
        </div>
    )
}